import React, { Children } from 'react';
import { motion } from 'framer-motion';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-50px'
}} transition={{
  duration: 0.5,
  delay
}} className={className} data-id="element-20">
    {children}
  </motion.div>;
export const StaggerContainer = ({
  children,
  className = ''
}: {
  children: ReactNode;
  className?: string;
}) => <motion.div initial="hidden" whileInView="visible" viewport={{
  once: true,
  margin: '-50px'
}} variants={{
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
}} className={className} data-id="element-21">
    {children}
  </motion.div>;
export const StaggerItem = ({
  children,
  className = ''
}: {
  children: ReactNode;
  className?: string;
}) => <motion.div variants={{
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
}} className={className} data-id="element-22">
    {children}
  </motion.div>;